import {
    GET_CATEGORY_DATA_START,
    GET_CATEGORY_DATA_SUCCESS,
    GET_CATEGORY_DATA_ERROR
} from '../../constants';
import { getActiveCategories as query } from '../../lib/graphql';

export function getCategory() {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: GET_CATEGORY_DATA_START,
            });

            const { data } = await client.query({ query, fetchPolicy: 'network-only' });
            if (!data?.getActiveCategories) {
                dispatch({
                    type: GET_CATEGORY_DATA_ERROR,
                });
            } else {
                dispatch({
                    type: GET_CATEGORY_DATA_SUCCESS,
                    categories: data?.getActiveCategories?.results
                });
            }
        } catch (error) {
            dispatch({
                type: GET_CATEGORY_DATA_ERROR,
                payload: {
                    error
                }
            });
            return false;
        }
        return true;
    };
}
